const scope_0 = require('/home/circleci/repo/.cache/caches/gatsby-mdx/mdx-scopes-dir/0e4d7d833622eb68d9c0c6b0ebb49166.js').default;
const scope_1 = require('/home/circleci/repo/.cache/caches/gatsby-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
const scope_2 = require('/home/circleci/repo/.cache/caches/gatsby-mdx/mdx-scopes-dir/30c188a00bb99a525ff1ee6255d546b3.js').default;
const scope_3 = require('/home/circleci/repo/.cache/caches/gatsby-mdx/mdx-scopes-dir/396137c612f90997a87983ae33834c27.js').default;
const scope_4 = require('/home/circleci/repo/.cache/caches/gatsby-mdx/mdx-scopes-dir/3fd79e0cfb2a14c0ef949228a607a6ba.js').default;
const scope_5 = require('/home/circleci/repo/.cache/caches/gatsby-mdx/mdx-scopes-dir/5295214ca088fab2684621bfdf06f8b0.js').default;
const scope_6 = require('/home/circleci/repo/.cache/caches/gatsby-mdx/mdx-scopes-dir/7b0b92405cc631e4e96b6107aecdc8c1.js').default;
const scope_7 = require('/home/circleci/repo/.cache/caches/gatsby-mdx/mdx-scopes-dir/8a8f601da442fdaef19cf3a8faa2e37a.js').default;
const scope_8 = require('/home/circleci/repo/.cache/caches/gatsby-mdx/mdx-scopes-dir/aa4d82c1f882b5c2af392494c875da11.js').default;
const scope_9 = require('/home/circleci/repo/.cache/caches/gatsby-mdx/mdx-scopes-dir/fa6ff0c29a29a991a5a889d8e5b400ef.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9 )
    